import type { ActivityItem } from '@atlassian/recent-work-client/query';

/**
 * rootContainerIds filter in the recent work component is limited to 5 cloudIds, so we need to filter the items
 * after fetching instead.
 * We hijack the recent work "custom grouping" function to filter the items :/
 */
export function postFetchFilterItemsByCloudIds(items: ActivityItem[], cloudIdsToFilterFor: string[]): ActivityItem[] {
	const noCloudIds = cloudIdsToFilterFor.length === 0;
	/**
	 * We want to show Trello items if the user has activity events from Trello.
	 *
	 * Trello, as a tenantless product, doesn't get an Atlassian
	 * orgId unless it's a Trello Enterprise, so Trello won't appear
	 * in the Atlassian Start recently worked on items.
	 *
	 * We bypass this check by passing TRELLO as a cloudId to filter for
	 * and allowing Trello to appear when the user has Trello activity
	 * events.
	 *
	 * https://atlassian.slack.com/archives/CV9TKT4CT/p1721073546189079
	 */
	const isTrelloFiltered = cloudIdsToFilterFor.includes('TRELLO');

	/**
	 * Bitbucket is also a tenantless product, so we need to filter for it if the user has activity events from Bitbucket.
	 */
	const isBitbucketFiltered = cloudIdsToFilterFor.includes('BITBUCKET');

	/**
	 * We want to show Graph items if the user has activity events from Graph these are
	 * generally 3rd party integrations (e.g. Bitbucket, etc).
	 */
	const isGraphFiltered = cloudIdsToFilterFor.includes('GRAPH');

	return noCloudIds
		? items
		: items.filter(item => {
				return (
					cloudIdsToFilterFor.some(cloudId => item.object.rootContainerIdentifier.ari.includes(cloudId)) ||
					(isTrelloFiltered && item.object.product === 'trello') ||
					(isGraphFiltered && item.object.product === 'graph') ||
					(isBitbucketFiltered && item.object.product === 'bitbucket')
				);
			});
}
